module.exports = __webpack_public_path__ + "img/vertical_4_6_3009.ed53d61a.png";